import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';

import { API_BASE_URL, HYPWAVE_TOOL_UPLOADER_ID } from '../config';

import {

  Card,

  CardContent,

  Typography,

  Box,

  Table,

  TableBody,

  TableCell,

  TableContainer,

  TableHead,

  TableRow,

  TablePagination,

  Chip,

  CircularProgress,

  Alert,

  IconButton,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  Button,

  FormControl,

  InputLabel,

  Select,

  MenuItem,

  TextField,

  Grid,

  Tooltip,

  Snackbar,

  Autocomplete,

  TableSortLabel,

  Link,

  InputAdornment

} from '@mui/material';

import ColumnVisibilityMenu, { ColumnOption } from '../components/ColumnVisibilityMenu';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import EditIcon from '@mui/icons-material/Edit';

import DeleteIcon from '@mui/icons-material/Delete';

import SearchIcon from '@mui/icons-material/Search';

import ClearIcon from '@mui/icons-material/Clear';

import AccessTimeIcon from '@mui/icons-material/AccessTime';

import SendIcon from '@mui/icons-material/Send';

import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';

import CancelIcon from '@mui/icons-material/Cancel';

import apiClient from '../api/client';
import {
  getCachedPublishers,
  getCachedCategories,
  getCachedUsers,
  invalidatePublishersCache
} from '../cache/appDataCache';
import {
  toAutocompleteOption,
  findLanguageOption,
  findCountryOption
} from '../utils/optionResolvers';

// Fallback categories if API fails
const FALLBACK_CATEGORIES = [
  { value: "AI_FUTURE_TECH", label: "AI & Future Tech" },
  { value: "AUTOMOBILE", label: "Automobile" },
  { value: "BUSINESS_ENTREPRENEURSHIP", label: "Business & Entrepreneurship" },
  { value: "CASINO", label: "Casino" },
  { value: "ECOMMERCE_STARTUPS", label: "E-commerce & Startups" },
  { value: "EDUCATION_CAREER", label: "Education & Career" },
  { value: "ENTERTAINMENT_MEDIA", label: "Entertainment & Media" },
  { value: "ENVIRONMENT", label: "Environment" },
  { value: "ESPORTS", label: "Esports" },
  { value: "FAMILY", label: "Family" },
  { value: "FASHION_BEAUTY", label: "Fashion & Beauty" },
  { value: "FINANCE_INVESTMENT", label: "Finance & Investment" },
  { value: "FOOD_NUTRITION", label: "Food & Nutrition" },
  { value: "GAMING", label: "Gaming" },
  { value: "GENERAL", label: "General" },
  { value: "HEALTH_FITNESS", label: "Health & Fitness" },
  { value: "HOME_IMPROVEMENT", label: "Home Improvement" },
  { value: "LAW", label: "Law" },
  { value: "LIFESTYLE_WELLNESS", label: "Lifestyle & Wellness" },
  { value: "MAGAZINE", label: "Magazine" },
  { value: "MARKETING_SEO", label: "Marketing & SEO" },
  { value: "NEWS", label: "News" },
  { value: "PARENTING_RELATIONSHIPS", label: "Parenting & Relationships" },
  { value: "REAL_ESTATE", label: "Real Estate" },
  { value: "SPORTS_FITNESS", label: "Sports & Fitness" },
  { value: "SUSTAINABILITY_GREEN_LIVING", label: "Sustainability & Green Living" },
  { value: "TECHNOLOGY_GADGETS", label: "Technology & Gadgets" },
  { value: "TRAVEL_TOURISM", label: "Travel & Tourism" },
  { value: "OTHERS", label: "Others" }
];



// Country options with ISO codes (matching main tool format)

const COUNTRIES = [

  { value: "AF", label: "Afghanistan" },

  { value: "AL", label: "Albania" },

  { value: "DZ", label: "Algeria" },

  { value: "AD", label: "Andorra" },

  { value: "AO", label: "Angola" },

  { value: "AG", label: "Antigua and Barbuda" },

  { value: "AR", label: "Argentina" },

  { value: "AM", label: "Armenia" },

  { value: "AU", label: "Australia" },

  { value: "AT", label: "Austria" },

  { value: "AZ", label: "Azerbaijan" },

  { value: "BS", label: "Bahamas" },

  { value: "BH", label: "Bahrain" },

  { value: "BD", label: "Bangladesh" },

  { value: "BB", label: "Barbados" },

  { value: "BY", label: "Belarus" },

  { value: "BE", label: "Belgium" },

  { value: "BZ", label: "Belize" },

  { value: "BJ", label: "Benin" },

  { value: "BT", label: "Bhutan" },

  { value: "BO", label: "Bolivia" },

  { value: "BA", label: "Bosnia and Herzegovina" },

  { value: "BW", label: "Botswana" },

  { value: "BR", label: "Brazil" },

  { value: "BN", label: "Brunei" },

  { value: "BG", label: "Bulgaria" },

  { value: "BF", label: "Burkina Faso" },

  { value: "BI", label: "Burundi" },

  { value: "CV", label: "Cabo Verde" },

  { value: "KH", label: "Cambodia" },

  { value: "CM", label: "Cameroon" },

  { value: "CA", label: "Canada" },

  { value: "CF", label: "Central African Republic" },

  { value: "TD", label: "Chad" },

  { value: "CL", label: "Chile" },

  { value: "CN", label: "China" },

  { value: "CO", label: "Colombia" },

  { value: "KM", label: "Comoros" },

  { value: "CG", label: "Congo" },

  { value: "CR", label: "Costa Rica" },

  { value: "HR", label: "Croatia" },

  { value: "CU", label: "Cuba" },

  { value: "CY", label: "Cyprus" },

  { value: "CZ", label: "Czech Republic" },

  { value: "DK", label: "Denmark" },

  { value: "DJ", label: "Djibouti" },

  { value: "DM", label: "Dominica" },

  { value: "DO", label: "Dominican Republic" },

  { value: "EC", label: "Ecuador" },

  { value: "EG", label: "Egypt" },

  { value: "SV", label: "El Salvador" },

  { value: "GQ", label: "Equatorial Guinea" },

  { value: "ER", label: "Eritrea" },

  { value: "EE", label: "Estonia" },

  { value: "SZ", label: "Eswatini" },

  { value: "ET", label: "Ethiopia" },

  { value: "FJ", label: "Fiji" },

  { value: "FI", label: "Finland" },

  { value: "FR", label: "France" },

  { value: "GA", label: "Gabon" },

  { value: "GM", label: "Gambia" },

  { value: "GE", label: "Georgia" },

  { value: "DE", label: "Germany" },

  { value: "GH", label: "Ghana" },

  { value: "GR", label: "Greece" },

  { value: "GD", label: "Grenada" },

  { value: "GT", label: "Guatemala" },

  { value: "GN", label: "Guinea" },

  { value: "GW", label: "Guinea-Bissau" },

  { value: "GY", label: "Guyana" },

  { value: "HT", label: "Haiti" },

  { value: "HN", label: "Honduras" },

  { value: "HU", label: "Hungary" },

  { value: "IS", label: "Iceland" },

  { value: "IN", label: "India" },

  { value: "ID", label: "Indonesia" },

  { value: "IR", label: "Iran" },

  { value: "IQ", label: "Iraq" },

  { value: "IE", label: "Ireland" },

  { value: "IL", label: "Israel" },

  { value: "IT", label: "Italy" },

  { value: "JM", label: "Jamaica" },

  { value: "JP", label: "Japan" },

  { value: "JO", label: "Jordan" },

  { value: "KZ", label: "Kazakhstan" },

  { value: "KE", label: "Kenya" },

  { value: "KI", label: "Kiribati" },

  { value: "KW", label: "Kuwait" },

  { value: "KG", label: "Kyrgyzstan" },

  { value: "LA", label: "Laos" },

  { value: "LV", label: "Latvia" },

  { value: "LB", label: "Lebanon" },

  { value: "LS", label: "Lesotho" },

  { value: "LR", label: "Liberia" },

  { value: "LY", label: "Libya" },

  { value: "LI", label: "Liechtenstein" },

  { value: "LT", label: "Lithuania" },

  { value: "LU", label: "Luxembourg" },

  { value: "MG", label: "Madagascar" },

  { value: "MW", label: "Malawi" },

  { value: "MY", label: "Malaysia" },

  { value: "MV", label: "Maldives" },

  { value: "ML", label: "Mali" },

  { value: "MT", label: "Malta" },

  { value: "MH", label: "Marshall Islands" },

  { value: "MR", label: "Mauritania" },

  { value: "MU", label: "Mauritius" },

  { value: "MX", label: "Mexico" },

  { value: "FM", label: "Micronesia" },

  { value: "MD", label: "Moldova" },

  { value: "MC", label: "Monaco" },

  { value: "MN", label: "Mongolia" },

  { value: "ME", label: "Montenegro" },

  { value: "MA", label: "Morocco" },

  { value: "MZ", label: "Mozambique" },

  { value: "MM", label: "Myanmar" },

  { value: "NA", label: "Namibia" },

  { value: "NR", label: "Nauru" },

  { value: "NP", label: "Nepal" },

  { value: "NL", label: "Netherlands" },

  { value: "NZ", label: "New Zealand" },

  { value: "NI", label: "Nicaragua" },

  { value: "NE", label: "Niger" },

  { value: "NG", label: "Nigeria" },

  { value: "KP", label: "North Korea" },

  { value: "MK", label: "North Macedonia" },

  { value: "NO", label: "Norway" },

  { value: "OM", label: "Oman" },

  { value: "PK", label: "Pakistan" },

  { value: "PW", label: "Palau" },

  { value: "PS", label: "Palestine" },

  { value: "PA", label: "Panama" },

  { value: "PG", label: "Papua New Guinea" },

  { value: "PY", label: "Paraguay" },

  { value: "PE", label: "Peru" },

  { value: "PH", label: "Philippines" },

  { value: "PL", label: "Poland" },

  { value: "PT", label: "Portugal" },

  { value: "QA", label: "Qatar" },

  { value: "RO", label: "Romania" },

  { value: "RU", label: "Russia" },

  { value: "RW", label: "Rwanda" },

  { value: "KN", label: "Saint Kitts and Nevis" },

  { value: "LC", label: "Saint Lucia" },

  { value: "VC", label: "Saint Vincent and the Grenadines" },

  { value: "WS", label: "Samoa" },

  { value: "SM", label: "San Marino" },

  { value: "ST", label: "Sao Tome and Principe" },

  { value: "SA", label: "Saudi Arabia" },

  { value: "SN", label: "Senegal" },

  { value: "RS", label: "Serbia" },

  { value: "SC", label: "Seychelles" },

  { value: "SL", label: "Sierra Leone" },

  { value: "SG", label: "Singapore" },

  { value: "SK", label: "Slovakia" },

  { value: "SI", label: "Slovenia" },

  { value: "SB", label: "Solomon Islands" },

  { value: "SO", label: "Somalia" },

  { value: "ZA", label: "South Africa" },

  { value: "KR", label: "South Korea" },

  { value: "SS", label: "South Sudan" },

  { value: "ES", label: "Spain" },

  { value: "LK", label: "Sri Lanka" },

  { value: "SD", label: "Sudan" },

  { value: "SR", label: "Suriname" },

  { value: "SE", label: "Sweden" },

  { value: "CH", label: "Switzerland" },

  { value: "SY", label: "Syria" },

  { value: "TW", label: "Taiwan" },

  { value: "TJ", label: "Tajikistan" },

  { value: "TZ", label: "Tanzania" },

  { value: "TH", label: "Thailand" },

  { value: "TL", label: "Timor-Leste" },

  { value: "TG", label: "Togo" },

  { value: "TO", label: "Tonga" },

  { value: "TT", label: "Trinidad and Tobago" },

  { value: "TN", label: "Tunisia" },

  { value: "TR", label: "Turkey" },

  { value: "TM", label: "Turkmenistan" },

  { value: "TV", label: "Tuvalu" },

  { value: "UG", label: "Uganda" },

  { value: "UA", label: "Ukraine" },

  { value: "AE", label: "United Arab Emirates" },

  { value: "UK", label: "United Kingdom" },

  { value: "US", label: "United States" },

  { value: "UY", label: "Uruguay" },

  { value: "UZ", label: "Uzbekistan" },

  { value: "VU", label: "Vanuatu" },

  { value: "VA", label: "Vatican City" },

  { value: "VE", label: "Venezuela" },

  { value: "VN", label: "Vietnam" },

  { value: "YE", label: "Yemen" },

  { value: "ZM", label: "Zambia" },

  { value: "ZW", label: "Zimbabwe" }

];



// Language options with lowercase short codes

const LANGUAGES = [

  { value: "en", label: "English" },

  { value: "es", label: "Spanish" },

  { value: "fr", label: "French" },

  { value: "de", label: "German" },

  { value: "it", label: "Italian" },

  { value: "pt", label: "Portuguese" },

  { value: "ru", label: "Russian" },

  { value: "zh", label: "Chinese" },

  { value: "ja", label: "Japanese" },

  { value: "ko", label: "Korean" },

  { value: "ar", label: "Arabic" },

  { value: "hi", label: "Hindi" },

  { value: "bn", label: "Bengali" },

  { value: "pa", label: "Punjabi" },

  { value: "ur", label: "Urdu" },

  { value: "vi", label: "Vietnamese" },

  { value: "th", label: "Thai" },

  { value: "tr", label: "Turkish" },

  { value: "pl", label: "Polish" },

  { value: "uk", label: "Ukrainian" },

  { value: "ro", label: "Romanian" },

  { value: "nl", label: "Dutch" },

  { value: "el", label: "Greek" },

  { value: "hu", label: "Hungarian" },

  { value: "cs", label: "Czech" },

  { value: "sv", label: "Swedish" },

  { value: "da", label: "Danish" },

  { value: "fi", label: "Finnish" },

  { value: "no", label: "Norwegian" },

  { value: "sk", label: "Slovak" },

  { value: "hr", label: "Croatian" },

  { value: "bg", label: "Bulgarian" },

  { value: "sr", label: "Serbian" },

  { value: "sl", label: "Slovenian" },

  { value: "lt", label: "Lithuanian" },

  { value: "lv", label: "Latvian" },

  { value: "et", label: "Estonian" },

  { value: "he", label: "Hebrew" },

  { value: "id", label: "Indonesian" },

  { value: "ms", label: "Malay" },

  { value: "tl", label: "Filipino" },

  { value: "sw", label: "Swahili" },

  { value: "fa", label: "Persian" },

  { value: "ta", label: "Tamil" },

  { value: "te", label: "Telugu" },

  { value: "mr", label: "Marathi" },

  { value: "gu", label: "Gujarati" },

  { value: "kn", label: "Kannada" },

  { value: "ml", label: "Malayalam" },

  { value: "ne", label: "Nepali" },

  { value: "si", label: "Sinhala" },

  { value: "my", label: "Burmese" },

  { value: "km", label: "Khmer" },

  { value: "lo", label: "Lao" },

  { value: "am", label: "Amharic" },

  { value: "other", label: "Other" }

];



interface Publisher {

  id: string;

  email: string | null;

  publisherName: string;

}



interface DataInProcess {

  id: string;

  websiteUrl: string;

  publisherEmail?: string;

  publisherName?: string;

  publisherId?: string;

  publisherMatched?: boolean;

  contactName?: string;

  contactEmail?: string;

  da?: number;

  dr?: number;

  traffic?: number;

  ss?: number;

  keywords?: number;

  domainAge?: string;

  imageLink?: string;

  category?: string;

  country?: string;

  language?: string;

  tat?: string;

  price?: number;

  gbBasePrice?: number;

  liBasePrice?: number;

  status: string;

  comment?: string;

  createdAt: string;

  updatedAt?: string;

  lastModifiedBy?: string;

  lastModifiedByUser?: {

    firstName: string;

    lastName: string;

    email: string;

    role: string;

  };

  uploadTask?: {

    fileName: string;

    assignedTo: string;

    createdBy: string;

    assignedToUser?: {

      firstName: string;

      lastName: string;

      email: string;

    };

    createdByUser?: {

      firstName: string;

      lastName: string;

      email: string;

    };

  };

}



// User type for filter dropdown

interface User {

  id: string;

  firstName: string;

  lastName: string;

  email: string;

  role: 'ADMIN' | 'SUPER_ADMIN' | 'CONTRIBUTOR' | 'SYSTEM';

}

const getUploaderFilterLabel = (user: User) =>
  user.id === HYPWAVE_TOOL_UPLOADER_ID
    ? 'Hypwave tool'
    : `${user.firstName} ${user.lastName} - (${user.role})`;



const DATA_MGMT_COLUMN_KEY = 'data-management-visible-columns';

function dataManagementColumns(role: string): ColumnOption[] {
  const cols: ColumnOption[] = [{ key: 'url', label: 'Site URL', required: true }];
  if (role === 'SUPER_ADMIN') {
    cols.push(
      { key: 'publisher', label: 'Publisher' },
      { key: 'publisherEmail', label: 'Publisher Email' }
    );
  }
  if (role !== 'CONTRIBUTOR') {
    cols.push(
      { key: 'contactName', label: 'Contact Name' },
      { key: 'contactEmail', label: 'Contact Email' }
    );
  }
  cols.push(
    { key: 'da', label: 'DA' },
    { key: 'dr', label: 'DR' },
    { key: 'traffic', label: 'Traffic' },
    { key: 'ss', label: 'SS' },
    { key: 'keywords', label: 'Keywords' },
    { key: 'domainAge', label: 'Domain Age' },
    { key: 'gbPrice', label: 'GB Base Price' },
    { key: 'liPrice', label: 'LI Base Price' },
    { key: 'category', label: 'Category' },
    { key: 'country', label: 'Country' },
    { key: 'language', label: 'Language' },
    { key: 'tat', label: 'TAT' },
    { key: 'status', label: 'Status' },
    { key: 'comment', label: 'Comment' },
    { key: 'lastModified', label: 'Last Modified' }
  );
  if (role === 'SUPER_ADMIN') {
    cols.push(
      { key: 'uploadedBy', label: 'Uploaded By' },
      { key: 'assignedTo', label: 'Assigned To' }
    );
  }
  return cols;
}

const DataManagement: React.FC = () => {

  const [data, setData] = useState<DataInProcess[]>([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [userRole, setUserRole] = useState<string>('');

  const [selectedRecord, setSelectedRecord] = useState<DataInProcess | null>(null);

  const [showEditDialog, setShowEditDialog] = useState(false);

  const [showViewDialog, setShowViewDialog] = useState(false);

  const [saving, setSaving] = useState(false);

  

  // Search and filter state

  const [searchText, setSearchText] = useState('');

  const [debouncedSearchText, setDebouncedSearchText] = useState('');

  const [filterAssignedTo, setFilterAssignedTo] = useState('');

  const [filterUploadedBy, setFilterUploadedBy] = useState('');

  const [filterPublisher, setFilterPublisher] = useState('');

  const [filterLanguage, setFilterLanguage] = useState('');

  const [filterCountry, setFilterCountry] = useState('');

  const [filterTlds, setFilterTlds] = useState<string[]>([]);
  const [adminVisibleTlds, setAdminVisibleTlds] = useState<string[]>([]);
  const [adminTldDialogOpen, setAdminTldDialogOpen] = useState(false);
  const [adminTldDraft, setAdminTldDraft] = useState<string[]>([]);
  const [adminTldCatalog, setAdminTldCatalog] = useState<Array<{ tld: string; count: number }>>([]);
  const [savingAdminTlds, setSavingAdminTlds] = useState(false);

  const [filterStatus, setFilterStatus] = useState('PENDING');

  const [filterKeywordsMin, setFilterKeywordsMin] = useState('');

  const [filterKeywordsMax, setFilterKeywordsMax] = useState('');

  const [debouncedKeywordsMin, setDebouncedKeywordsMin] = useState('');

  const [debouncedKeywordsMax, setDebouncedKeywordsMax] = useState('');

  const [availableTlds, setAvailableTlds] = useState<Array<{ tld: string; count: number }>>([]);

  const [availableLanguages, setAvailableLanguages] = useState<Array<{ code: string; label: string; count: number }>>([]);

  const [availableCountries, setAvailableCountries] = useState<Array<{ code: string; label: string; count: number }>>([]);

  const [users, setUsers] = useState<User[]>([]);

  const [uploaders, setUploaders] = useState<User[]>([]);

  const [sortBy, setSortBy] = useState<'url' | 'price' | 'status' | 'lastModified' | 'language' | 'country' | 'dr' | 'traffic'>('url');

  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const columnOptions = useMemo(() => dataManagementColumns(userRole), [userRole]);

  const [visibleColumns, setVisibleColumns] = useState<Set<string>>(() => {
    try {
      const raw = localStorage.getItem(DATA_MGMT_COLUMN_KEY);
      if (raw) {
        const saved = JSON.parse(raw) as string[];
        if (Array.isArray(saved) && saved.length > 0) {
          return new Set([...saved, 'url']);
        }
      }
    } catch {
      // ignore bad storage
    }
    return new Set(dataManagementColumns('SUPER_ADMIN').map((c) => c.key));
  });

  const showCol = (key: string) => key === 'url' || visibleColumns.has(key);

  const toggleColumn = (key: string) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      next.add('url');
      localStorage.setItem(DATA_MGMT_COLUMN_KEY, JSON.stringify([...next]));
      return next;
    });
  };

  

  // Bulk selection state

  const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());

  const [bulkActionLoading, setBulkActionLoading] = useState(false);
  const [rowAction, setRowAction] = useState<{ id: string; status: 'READY_TO_SEND' | 'NO_ACTION_NEEDED' } | null>(null);
  const [showBulkRejectDialog, setShowBulkRejectDialog] = useState(false);
  const [bulkRejectComment, setBulkRejectComment] = useState('');

  

  // Pagination state

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(50);
  const lastFetchTimeRef = useRef(0);
  const VISIBILITY_REFRESH_MS = 60000;

  const [total, setTotal] = useState(0);

  const [goToPageInput, setGoToPageInput] = useState('');

  

  // Publisher state

  const [publishers, setPublishers] = useState<Publisher[]>([]);

  const [loadingPublishers, setLoadingPublishers] = useState(false);

  const [selectedPublisher, setSelectedPublisher] = useState<Publisher | null>(null);

  const [creatingPublisher, setCreatingPublisher] = useState(false);

  const [allPublisherEmails, setAllPublisherEmails] = useState<Array<{ email: string; count: number }>>([]);

  

  // Categories state
  const [categories, setCategories] = useState<Array<{ value: string; label: string }>>(FALLBACK_CATEGORIES);

  // Toast notification state

  const [snackbar, setSnackbar] = useState<{

    open: boolean;

    message: string;

    severity: 'success' | 'error' | 'info' | 'warning';

  }>({

    open: false,

    message: '',

    severity: 'success'

  });

  

  // Recently updated rows for success animation

  const [recentlyUpdated, setRecentlyUpdated] = useState<Set<string>>(new Set());

  

  // Edit form state

  const [editFormData, setEditFormData] = useState({

    publisherEmail: '',

    publisherName: '',

    publisherId: '',

    publisherMatched: false,

    contactName: '',

    contactEmail: '',

    da: '',

    dr: '',

    traffic: '',

    ss: '',

    keywords: '',

    domainAge: '',

    gbBasePrice: '',

    liBasePrice: '',

    category: '',

    country: '',

    language: '',

    tat: '',

    status: '',

    comment: '',

    imageLink: ''

  });



  // Fetch publishers from main project (shared cache — once across modules)

  const fetchPublishers = useCallback(async (forceRefresh = false): Promise<Publisher[]> => {
    setLoadingPublishers(true);
    try {
      const list = await getCachedPublishers(forceRefresh);
      setPublishers(list);
      return list;
    } catch (err) {
      console.error('Failed to fetch publishers:', err);
    } finally {
      setLoadingPublishers(false);
    }
    return [];
  }, []);



  // Fetch users for filter dropdown

  const [loadingUsers, setLoadingUsers] = useState(false);

  const fetchUsers = useCallback(async () => {

    setLoadingUsers(true);

    try {

      const usersList = await getCachedUsers();

      // Filter to show only ADMINs in "Assigned To" dropdown

      setUsers(usersList.filter((u: any) => u.role === 'ADMIN'));

      // Uploaded By: contributors only (admins assign data; Hypwave added via API)
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

      if (currentUser.role === 'SUPER_ADMIN') {

        setUploaders(usersList.filter((u: any) => u.role === 'CONTRIBUTOR'));

      }

      // For ADMIN: uploaders are fetched separately via /data-in-process/uploaders

    } catch (err) {

      console.error('Failed to fetch users:', err);

      setUsers([]);

    } finally {

      setLoadingUsers(false);

    }

  }, []);



  // Shared filter params sent to the filter-option endpoints so dropdown
  // counts reflect the currently visible (role-scoped + filtered) data.
  // Each endpoint ignores its own filter server-side so its full option list stays available.
  const filterOptionParams = useMemo(() => {
    const params: any = {};
    if (debouncedSearchText) params.search = debouncedSearchText;
    if (filterAssignedTo) params.assignedTo = filterAssignedTo;
    if (filterUploadedBy) params.uploadedBy = filterUploadedBy;
    if (filterPublisher) params.publisher = filterPublisher;
    if (filterLanguage) params.language = filterLanguage;
    if (filterCountry) params.country = filterCountry;
    if (filterTlds.length) params.tlds = filterTlds.join(',');
    if (filterStatus) params.status = filterStatus;
    if (debouncedKeywordsMin) params.keywordsMin = debouncedKeywordsMin;
    if (debouncedKeywordsMax) params.keywordsMax = debouncedKeywordsMax;
    return params;
  }, [debouncedSearchText, filterAssignedTo, filterUploadedBy, filterPublisher, filterLanguage, filterCountry, filterTlds, filterStatus, debouncedKeywordsMin, debouncedKeywordsMax]);



  // Fetch distinct uploaders for ADMIN users from their actual assigned data

  const fetchUploaders = useCallback(async () => {

    try {

      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/uploaders`, { params: filterOptionParams });

      if (response.data.success) {

        const apiUploaders: User[] = (response.data.data || []).filter(
          (user: User) => user.role !== 'ADMIN'
        );
        const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

        if (currentUser.role === 'SUPER_ADMIN') {
          setUploaders((prev) => {
            const byId = new Map(
              prev.filter((user) => user.role !== 'ADMIN').map((user) => [user.id, user])
            );
            for (const user of apiUploaders) {
              byId.set(user.id, user);
            }
            return Array.from(byId.values());
          });
        } else {
          setUploaders(apiUploaders);
        }

      }

    } catch (err) {

      console.error('Failed to fetch uploaders:', err);

    }

  }, [filterOptionParams]);



  const fetchPublisherOptions = useCallback(async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/publishers`, { params: filterOptionParams });
      if (response.data.success) {
        setAllPublisherEmails(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch publisher options:', err);
    }
  }, [filterOptionParams]);

  const fetchTlds = useCallback(async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/tlds`, { params: filterOptionParams });
      if (response.data.success) {
        setAvailableTlds(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch TLDs:', err);
    }
  }, [filterOptionParams]);

  const loadAdminVisibleTlds = useCallback(async () => {
    if (userRole !== 'SUPER_ADMIN') return;
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/admin-tlds`);
      if (response.data.success) {
        setAdminVisibleTlds(response.data.data?.tlds || []);
      }
    } catch (err) {
      console.error('Failed to load admin TLD settings:', err);
    }
  }, [userRole]);

  useEffect(() => {
    loadAdminVisibleTlds();
  }, [loadAdminVisibleTlds]);

  const openAdminTldDialog = async () => {
    setAdminTldDialogOpen(true);
    setAdminTldDraft(adminVisibleTlds);
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/tlds`);
      if (response.data.success) {
        setAdminTldCatalog(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to load TLD catalog:', err);
    }
  };

  const saveAdminTlds = async () => {
    setSavingAdminTlds(true);
    try {
      const response = await apiClient.put(`${API_BASE_URL}/data-in-process/admin-tlds`, {
        tlds: adminTldDraft
      });
      if (response.data.success) {
        const saved = response.data.data?.tlds || [];
        setAdminVisibleTlds(saved);
        setAdminTldDialogOpen(false);
        showToast(response.data.message || 'Admin TLD list saved', 'success');
      }
    } catch (err: any) {
      showToast(err.response?.data?.message || err.response?.data?.error || 'Failed to save admin TLDs', 'error');
    } finally {
      setSavingAdminTlds(false);
    }
  };

  const fetchLanguageOptions = useCallback(async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/languages`, { params: filterOptionParams });
      if (response.data.success) {
        setAvailableLanguages(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch languages:', err);
    }
  }, [filterOptionParams]);

  const fetchCountryOptions = useCallback(async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/data-in-process/countries`, { params: filterOptionParams });
      if (response.data.success) {
        setAvailableCountries(response.data.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch countries:', err);
    }
  }, [filterOptionParams]);



  // Get user role from localStorage or auth context

  useEffect(() => {

    const user = JSON.parse(localStorage.getItem('user') || '{}');

    setUserRole(user.role || '');

  }, []);

  // Fetch categories from API on component mount (shared cache)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const list = await getCachedCategories();
        if (list.length > 0) {
          setCategories(list);
        }
      } catch (error) {
        console.error('Error fetching categories from API, using fallback:', error);
        // Categories already initialized with FALLBACK_CATEGORIES
      }
    };

    fetchCategories();
  }, []);



  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (user.role === 'SUPER_ADMIN' || user.role === 'ADMIN') {
      fetchUsers();
    }
  }, [fetchUsers]);

  // Debounced filter-option refresh — keeps counts accurate without spamming APIs on every click
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const timer = setTimeout(() => {
      if (user.role === 'SUPER_ADMIN' || user.role === 'ADMIN') {
        fetchUploaders();
      }

      if (user.role !== 'CONTRIBUTOR') {
        fetchPublisherOptions();
      }

      fetchTlds();
      fetchLanguageOptions();
      fetchCountryOptions();
    }, 450);

    return () => clearTimeout(timer);
  }, [fetchUploaders, fetchPublisherOptions, fetchTlds, fetchLanguageOptions, fetchCountryOptions]);



  // Auto-refresh removed - pagination handles data loading

  // Users can manually refresh if needed



  // Debounce search text - wait 500ms after user stops typing

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
      setPage(0);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);



  // Debounce keywords range inputs - wait 500ms after user stops typing

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedKeywordsMin(filterKeywordsMin);
      setDebouncedKeywordsMax(filterKeywordsMax);
      setPage(0);
    }, 500);

    return () => clearTimeout(timer);
  }, [filterKeywordsMin, filterKeywordsMax]);



  // Define fetchData with useCallback to use in dependency arrays

  const fetchData = useCallback(async (showLoadingSpinner = true) => {

    // Only show loading spinner on initial load or explicit refresh

    if (showLoadingSpinner) {

      setLoading(true);

    }

    setError('');

    

    try {

      // Map frontend column names to backend database field names

      const sortByMapping: Record<string, string> = {

        'url': 'websiteUrl',

        'price': 'price',

        'status': 'status',

        'lastModified': 'updatedAt',

        'language': 'language',

        'country': 'country',

        'dr': 'dr',

        'traffic': 'traffic'

      };

      

      // Build params object with pagination, filters, and sorting

      const params: any = {

        page: page + 1,

        limit: rowsPerPage,

        sortBy: sortByMapping[sortBy] || 'createdAt',

        sortOrder: sortOrder

      };

      

      // Add search parameter if exists (using debounced value)

      if (debouncedSearchText) {

        params.search = debouncedSearchText;

      }

      

      // Add filter parameters if they exist

      if (filterAssignedTo) {

        params.assignedTo = filterAssignedTo;

      }

      

      if (filterUploadedBy) {

        params.uploadedBy = filterUploadedBy;

      }

      

      if (filterPublisher) {

        params.publisher = filterPublisher;

      }

      if (filterLanguage) {

        params.language = filterLanguage;

      }

      if (filterCountry) {

        params.country = filterCountry;

      }

      if (filterTlds.length) {

        params.tlds = filterTlds.join(',');

      }

      if (filterStatus) {

        params.status = filterStatus;

      }

      if (debouncedKeywordsMin) {

        params.keywordsMin = debouncedKeywordsMin;

      }

      if (debouncedKeywordsMax) {

        params.keywordsMax = debouncedKeywordsMax;

      }

      

      const response = await apiClient.get(`${API_BASE_URL}/data-in-process`, {

        params

      });



      if (response.data.success) {

        // Backend returns { data: { data: [...], pagination: {...} } }

        const result = response.data.data;

        setData(result.data || []);

        setTotal(result.pagination.total || 0);

        lastFetchTimeRef.current = Date.now();

      }

    } catch (err: any) {

      console.error('Error fetching data:', err);

      setError(err.response?.data?.message || 'Failed to load data');

    } finally {

      setLoading(false);

    }

  }, [page, rowsPerPage, sortBy, sortOrder, debouncedSearchText, filterAssignedTo, filterUploadedBy, filterPublisher, filterLanguage, filterCountry, filterTlds, filterStatus, debouncedKeywordsMin, debouncedKeywordsMax]);



  // Refetch data when pagination, sorting, or filters change

  useEffect(() => {

    fetchData();

  }, [fetchData]);



  // Refresh data when user returns to the tab (for multi-system sync)

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const now = Date.now();
        if (now - lastFetchTimeRef.current >= VISIBILITY_REFRESH_MS) {
          fetchData(false);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [fetchData]);



  const getStatusColor = (status: string) => {

    switch (status) {

      case 'PENDING':

        return 'warning';

      case 'READY_TO_SEND':

        return 'info';

      case 'REACHED':

        return 'success';

      case 'NOT_REACHED':

        return 'error';

      case 'VERIFIED':

        return 'info';

      default:

        return 'default';

    }

  };



  // Get category label from value

  const getCategoryLabel = (value: string | undefined) => {

    if (!value) return null;

    const category = categories.find(c => c.value === value);

    return category ? category.label : value;

  };



  // Get language label from value

  const getLanguageLabel = (value: string | undefined) => {

    if (!value) return null;

    const language = findLanguageOption(LANGUAGES, value);

    return language ? language.label : value;

  };



  // Get country label from value

  const getCountryLabel = (value: string | undefined) => {

    if (!value) return null;

    const country = findCountryOption(COUNTRIES, value);

    return country ? country.label : value;

  };



  const formatDate = (dateString: string) => {

    return new Date(dateString).toLocaleDateString('en-US', {

      year: 'numeric',

      month: 'short',

      day: 'numeric',

      hour: '2-digit',

      minute: '2-digit'

    });

  };



  const handleView = (record: DataInProcess) => {

    setSelectedRecord(record);

    setShowViewDialog(true);

  };



  const handleEdit = async (record: DataInProcess) => {

    setSelectedRecord(record);

    setEditFormData({

      publisherEmail: record.publisherEmail || '',

      publisherName: record.publisherName || '',

      publisherId: record.publisherId || '',

      publisherMatched: record.publisherMatched || false,

      contactName: record.contactName || '',

      contactEmail: record.contactEmail || '',

      da: record.da?.toString() || '',

      dr: record.dr?.toString() || '',

      traffic: record.traffic?.toString() || '',

      ss: record.ss?.toString() || '',

      keywords: record.keywords?.toString() || '',

      domainAge: record.domainAge ? String(record.domainAge).replace(/[^0-9]/g, '') : '',

      gbBasePrice: (record.price || record.gbBasePrice)?.toString() || '',

      liBasePrice: record.liBasePrice?.toString() || '',

      category: record.category || '',

      country: record.country || '',

      language: record.language || '',

      tat: record.tat || '',

      status: record.status,

      comment: record.comment || '',

      imageLink: (record as any).imageLink || ''

    });

    let publisherList = publishers;
    if (publisherList.length === 0) {
      publisherList = await fetchPublishers();
    }

    if (record.publisherMatched && record.publisherId) {
      const matchingPublisher = publisherList.find(p => p.id === record.publisherId);
      setSelectedPublisher(matchingPublisher || null);
    } else {
      setSelectedPublisher(null);
    }

    setShowEditDialog(true);

  };



  // Handle publisher selection - auto-fill email and name

  const handlePublisherChange = (publisher: Publisher | null) => {

    setSelectedPublisher(publisher);

    if (publisher) {

      setEditFormData(prev => ({

        ...prev,

        publisherEmail: publisher.email || '',

        publisherName: publisher.publisherName || ''

      }));

    }

  };



  // Handle marking contact info as publisher

  const handleCreatePublisherFromEdit = async () => {

    if (!selectedRecord) return;

    

    const name = editFormData.contactName;

    const email = editFormData.contactEmail;

    

    if (!name && !email) {

      showToast('Please enter contact name or email first', 'warning');

      return;

    }

    

    setCreatingPublisher(true);

    try {

      const response = await apiClient.post(

        `${API_BASE_URL}/publishers`,

        {

          name: name || email?.split('@')[0] || 'Unknown',

          email: email || '',

          publisherId: editFormData.publisherId || undefined

        }

      );

      

      if (response.data.success) {

        // Update the form data with the new publisher info

        setEditFormData(prev => ({

          ...prev,

          publisherId: response.data.data.id,

          publisherName: response.data.data.publisherName,

          publisherEmail: response.data.data.email || '',

          publisherMatched: true

        }));

        

        // Update the record in the list

        setData(data.map(item => 

          item.id === selectedRecord.id 

            ? { 

                ...item, 

                publisherId: response.data.data.id,

                publisherName: response.data.data.publisherName,

                publisherEmail: response.data.data.email,

                publisherMatched: true

              }

            : item

        ));

        

        showToast(`Marked as Publisher: "${response.data.data.publisherName}"`, 'success');

        invalidatePublishersCache();
        fetchPublishers(true); // Refresh shared publishers list after create

      }

    } catch (err: any) {

      console.error('Error marking as publisher:', err);

      showToast(err.response?.data?.error || 'Failed to mark as publisher', 'error');

    } finally {

      setCreatingPublisher(false);

    }

  };



  // Helper function to show toast notifications

  const showToast = (message: string, severity: 'success' | 'error' | 'info' | 'warning' = 'success') => {

    setSnackbar({ open: true, message, severity });

  };

  const handleRowStatusAction = async (
    row: DataInProcess,
    status: 'READY_TO_SEND' | 'NO_ACTION_NEEDED'
  ) => {
    if (rowAction) return;
    setRowAction({ id: row.id, status });
    try {
      const response = await apiClient.put(`${API_BASE_URL}/data-in-process/${row.id}`, { status });
      if (!response.data.success) return;

      if (status === 'NO_ACTION_NEEDED') {
        setData((prev) => prev.filter((item) => item.id !== row.id));
        setTotal((prev) => Math.max(0, prev - 1));
        setSelectedRows((prev) => {
          const next = new Set(prev);
          next.delete(row.id);
          return next;
        });
        showToast('Record rejected and moved to Rejected Data!', 'success');
      } else {
        setData((prev) =>
          prev.map((item) =>
            item.id === row.id
              ? { ...item, ...response.data.data, createdAt: item.createdAt, status: 'READY_TO_SEND' }
              : item
          )
        );
        setRecentlyUpdated((prev) => new Set([...Array.from(prev), row.id]));
        setTimeout(() => {
          setRecentlyUpdated((prev) => {
            const next = new Set(prev);
            next.delete(row.id);
            return next;
          });
        }, 2000);
        showToast('Marked as Ready to send', 'success');
      }
    } catch (err: any) {
      if (err.response?.status === 404) {
        showToast('This record has been moved or deleted by another user.', 'warning');
        setData((prev) => prev.filter((item) => item.id !== row.id));
        setTotal((prev) => Math.max(0, prev - 1));
      } else {
        showToast(
          err.response?.data?.message || err.response?.data?.error || 'Failed to update record',
          'error'
        );
      }
    } finally {
      setRowAction(null);
    }
  };



  const handleDelete = async (id: string) => {

    if (!window.confirm('Are you sure you want to delete this record?')) {

      return;

    }



    try {

      await apiClient.delete(`${API_BASE_URL}/data-in-process/${id}`);



      setData(data.filter(item => item.id !== id));
      setTotal(prev => Math.max(0, prev - 1));

      showToast('Record deleted successfully', 'success');

    } catch (err: any) {

      console.error('Error deleting record:', err);

      showToast(err.response?.data?.message || 'Failed to delete record', 'error');

    }

  };



  const handleSaveEdit = async () => {

    if (!selectedRecord) return;



    // Validate DR and Traffic are required

    if (!editFormData.dr || !editFormData.traffic) {

      showToast('DR and Traffic fields are required before saving', 'warning');

      return;

    }



    // Comment is now optional for Rejected (NO_ACTION_NEEDED) and NOT_REACHED statuses

    // No validation needed - users can choose to add a comment or not



    setSaving(true);

    try {

      // Prepare update data

      const updateData: any = {

        publisherEmail: editFormData.publisherEmail,

        publisherName: editFormData.publisherName,

        publisherId: editFormData.publisherId || undefined,

        publisherMatched: editFormData.publisherMatched,

        contactName: editFormData.contactName || undefined,

        contactEmail: editFormData.contactEmail || undefined,

        da: editFormData.da ? parseInt(editFormData.da) : undefined,

        dr: editFormData.dr ? parseInt(editFormData.dr) : undefined,

        traffic: editFormData.traffic ? parseInt(editFormData.traffic) : undefined,

        ss: editFormData.ss ? parseInt(editFormData.ss) : undefined,

        keywords: editFormData.keywords ? parseInt(editFormData.keywords) : undefined,

        domainAge: editFormData.domainAge
          ? String(editFormData.domainAge).replace(/[^0-9]/g, '').slice(0, 64) || undefined
          : undefined,

        price: editFormData.gbBasePrice ? parseFloat(editFormData.gbBasePrice) : undefined,

        gbBasePrice: editFormData.gbBasePrice ? parseFloat(editFormData.gbBasePrice) : undefined,

        liBasePrice: editFormData.liBasePrice ? parseFloat(editFormData.liBasePrice) : undefined,

        category: editFormData.category,

        country: editFormData.country,

        language: editFormData.language,

        tat: editFormData.tat,

        status: editFormData.status,

        comment: editFormData.comment || undefined,

        imageLink: editFormData.imageLink?.trim() || undefined

      };



      const response = await apiClient.put(

        `${API_BASE_URL}/data-in-process/${selectedRecord.id}`,

        updateData

      );



      if (response.data.success) {

        // Save scroll position before updating state

        const scrollY = window.scrollY;



        // If status changed to REACHED, remove from list (moved to Data Final)

        if (editFormData.status === 'REACHED') {

          setData(data.filter(item => item.id !== selectedRecord.id));
          setTotal(prev => Math.max(0, prev - 1));

          showToast('Record marked as Email Sent and moved to Data Final!', 'success');

        } else if (editFormData.status === 'NO_ACTION_NEEDED') {

          // Rejected - remove from list (moved to Rejected Data)

          setData(data.filter(item => item.id !== selectedRecord.id));
          setTotal(prev => Math.max(0, prev - 1));

          showToast('Record rejected and moved to Rejected Data!', 'success');

        } else {

          // Update the record in-place, preserving original sort fields to keep row position stable

          setData(data.map(item => 

            item.id === selectedRecord.id 

              ? { ...item, ...response.data.data, createdAt: item.createdAt }

              : item

          ));

          

          // Add success animation

          setRecentlyUpdated(new Set([...Array.from(recentlyUpdated), selectedRecord.id]));

          setTimeout(() => {

            setRecentlyUpdated(prev => {

              const next = new Set(prev);

              next.delete(selectedRecord.id);

              return next;

            });

          }, 2000);

          

          showToast('Record updated successfully', 'success');

        }

        setShowEditDialog(false);

        setSelectedRecord(null);



        // Restore scroll position after React re-render

        requestAnimationFrame(() => {

          window.scrollTo(0, scrollY);

        });

      }

    } catch (err: any) {

      console.error('Error updating record:', err);

      

      // Handle 404 - record was moved/deleted by another user

      if (err.response?.status === 404) {

        showToast('This record has been moved or deleted by another user.', 'warning');

        setShowEditDialog(false);

        setSelectedRecord(null);

        

        // Immediately remove from local state without full refresh

        setData(data.filter(item => item.id !== selectedRecord.id));

        setTotal(prev => Math.max(0, prev - 1));

      } else {

        showToast(err.response?.data?.message || 'Failed to update record', 'error');

      }

    } finally {

      setSaving(false);

    }

  };



  const getStatusHexColor = (status: string) => {
    switch (status) {
      case 'PENDING':
        return '#ff9800';
      case 'READY_TO_SEND':
        return '#0288d1';
      case 'REACHED':
        return '#2e7d32';
      case 'NOT_REACHED':
        return '#d32f2f';
      case 'NO_ACTION_NEEDED':
        return '#616161';
      default:
        return '#ff9800';
    }
  };

  const getStatusIcon = (status: string) => {
    const color = getStatusHexColor(status);
    const sx = { fontSize: 18, color };
    switch (status) {
      case 'PENDING':
        return <AccessTimeIcon sx={sx} />;
      case 'READY_TO_SEND':
        return <SendIcon sx={sx} />;
      case 'REACHED':
        return <MarkEmailReadIcon sx={sx} />;
      case 'NOT_REACHED':
        return <MarkEmailUnreadIcon sx={sx} />;
      case 'NO_ACTION_NEEDED':
        return <CancelIcon sx={sx} />;
      default:
        return <AccessTimeIcon sx={sx} />;
    }
  };



  const getStatusLabel = (status: string) => {

    switch (status) {

      case 'PENDING':

        return 'Pending';

      case 'READY_TO_SEND':

        return 'Ready to send';

      case 'REACHED':

        return 'Email Sent';

      case 'NOT_REACHED':

        return 'Email Failed';

      case 'NO_ACTION_NEEDED':

        return 'Rejected';

      default:

        return status;

    }

  };



  // Bulk mark as reached handler

  const handleBulkMarkAsReached = async () => {

    if (selectedRows.size === 0) {

      showToast('Please select at least one site to mark as Email Sent', 'warning');

      return;

    }



    const confirmed = window.confirm(

      `Are you sure you want to mark ${selectedRows.size} site(s) as Email Sent?\n\nThese sites will be moved to Data Final.`

    );



    if (!confirmed) return;



    setBulkActionLoading(true);

    try {

      const selectedIds = Array.from(selectedRows);

      

      // Update each selected record with individual error handling

      const results = await Promise.allSettled(

        selectedIds.map(id =>

          apiClient.put(

            `${API_BASE_URL}/data-in-process/${id}`,

            { status: 'REACHED' }

          )

        )

      );



      // Count successes and failures

      const successful = results.filter(r => r.status === 'fulfilled').length;

      const failed = results.filter(r => r.status === 'rejected').length;



      // Remove marked records from the list

      setData(data.filter(item => !selectedRows.has(item.id)));
      setTotal(prev => Math.max(0, prev - successful));
      setSelectedRows(new Set());

      

      if (failed === 0) {

        showToast(`Successfully marked ${successful} site(s) as Email Sent and moved to Data Final!`, 'success');

      } else {

        showToast(`Completed: ${successful} succeeded, ${failed} failed. Refreshing data...`, 'warning');

      }

      

      // Refresh data to show current state

      fetchData();

    } catch (err: any) {

      console.error('Error bulk marking as reached:', err);

      showToast('Failed to mark sites as reached. Please try again.', 'error');

      // Refresh data to show current state

      fetchData();

    } finally {

      setBulkActionLoading(false);

    }

  };

  const handleBulkMarkAsRejected = () => {
    if (selectedRows.size === 0) {
      showToast('Please select at least one site to reject', 'warning');
      return;
    }
    setBulkRejectComment('');
    setShowBulkRejectDialog(true);
  };

  const handleConfirmBulkReject = async () => {
    setBulkActionLoading(true);
    try {
      const selectedIds = Array.from(selectedRows);

      const response = await apiClient.post(
        `${API_BASE_URL}/data-in-process/bulk-reject`,
        {
          ids: selectedIds,
          comment: bulkRejectComment.trim() || undefined
        }
      );

      if (response.data.success) {
        const { successful = 0, failed = 0 } = response.data.data || {};
        setData(data.filter(item => !selectedRows.has(item.id)));
        setTotal(prev => Math.max(0, prev - successful));
        setSelectedRows(new Set());
        setShowBulkRejectDialog(false);
        setBulkRejectComment('');

        if (failed === 0) {
          showToast(
            response.data.message || `Successfully rejected ${successful} site(s)!`,
            'success'
          );
        } else {
          showToast(
            response.data.message || `Rejected ${successful} site(s), ${failed} failed`,
            'warning'
          );
          fetchData();
        }
      } else {
        showToast('Failed to reject sites. Please try again.', 'error');
      }
    } catch (err: any) {
      console.error('Error bulk rejecting:', err);
      showToast(err.response?.data?.message || 'Failed to reject sites. Please try again.', 'error');
      fetchData();
    } finally {
      setBulkActionLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    if (selectedRows.size === 0) {
      showToast('Please select at least one site to delete', 'warning');
      return;
    }

    const confirmed = window.confirm(
      `Are you sure you want to permanently delete ${selectedRows.size} site(s)?\n\nThis action cannot be undone.`
    );

    if (!confirmed) return;

    setBulkActionLoading(true);
    try {
      const selectedIds = Array.from(selectedRows);
      
      const response = await apiClient.post(
        `${API_BASE_URL}/data-in-process/bulk-delete`,
        { ids: selectedIds }
      );

      if (response.data.success) {
        showToast(response.data.message || `Successfully deleted ${selectedIds.length} site(s)`, 'success');
        setData(data.filter(item => !selectedRows.has(item.id)));
        setSelectedRows(new Set());
        fetchData();
      } else {
        showToast('Failed to delete sites. Please try again.', 'error');
      }
    } catch (err: any) {
      console.error('Error bulk deleting:', err);
      showToast(err.response?.data?.message || 'Failed to delete sites. Please try again.', 'error');
      fetchData();
    } finally {
      setBulkActionLoading(false);
    }
  };



  // Use server-side paginated data directly (no client-side filtering needed)

  const paginatedData = data;

  

  // Handle sort

  const handleSort = (column: 'url' | 'price' | 'status' | 'lastModified' | 'language' | 'country' | 'dr' | 'traffic') => {

    if (sortBy === column) {

      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');

    } else {

      setSortBy(column);

      setSortOrder('asc');

    }

  };



  // Handle page change

  const handleChangePage = (_event: unknown, newPage: number) => {

    setPage(newPage);

  };



  // Handle rows per page change

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const next = Math.min(parseInt(event.target.value, 10), 1000);
    setRowsPerPage(next);
    setPage(0);
  };



  // Handle go to page

  const handleGoToPage = () => {

    const pageNum = parseInt(goToPageInput, 10);

    const maxPage = Math.ceil(total / rowsPerPage) - 1;

    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= maxPage + 1) {

      setPage(pageNum - 1); // Convert to 0-indexed

      setGoToPageInput('');

    }

  };



  const handleGoToPageKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {

    if (event.key === 'Enter') {

      handleGoToPage();

    }

  };



  return (

    <Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, mb: 4 }}>

        <Box>

          <Typography variant="h4" gutterBottom fontWeight="bold">

            Data Management

          </Typography>

          <Typography variant="body1" color="text.secondary">

            View and manage guest blog website data in process

          </Typography>

        </Box>

        <ColumnVisibilityMenu
          columns={columnOptions}
          visible={visibleColumns}
          onToggle={toggleColumn}
        />

      </Box>



      {error && (

        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>

          {error}

        </Alert>

      )}



      <Card>

        <CardContent>

          {/* Search and Filter Section */}

          <Box sx={{ mb: 3, display: 'flex', gap: 2, rowGap: 2.5, flexWrap: 'wrap', alignItems: 'center' }}>

            <TextField
              size="small"
              label="Search site URL"
              placeholder="Type to search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ width: 240, minWidth: 240 }}
              InputProps={{
                startAdornment: (
                  <Box component="span" sx={{ mr: 0.5, display: 'flex', color: 'text.secondary' }}>
                    <SearchIcon fontSize="small" />
                  </Box>
                ),
                endAdornment: searchText ? (
                  <IconButton size="small" onClick={() => setSearchText('')} edge="end" aria-label="clear search">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ) : undefined
              }}
            />

            {userRole === 'SUPER_ADMIN' && (
              <Autocomplete
                size="small"
                options={[
                  { id: '', label: 'All Admins' },
                  ...users.map((user) => ({
                    id: user.id,
                    label: `${user.firstName} ${user.lastName} - (ADMIN)`
                  }))
                ]}
                value={
                  !filterAssignedTo
                    ? { id: '', label: 'All Admins' }
                    : users
                        .map((user) => ({
                          id: user.id,
                          label: `${user.firstName} ${user.lastName} - (ADMIN)`
                        }))
                        .find((o) => o.id === filterAssignedTo) || { id: '', label: 'All Admins' }
                }
                onChange={(_, option) => {
                  setPage(0);
                  setFilterAssignedTo(option?.id || '');
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                renderInput={(params) => (
                  <TextField {...params} label="Assigned To" placeholder="Search admin..." />
                )}
                sx={{ width: 220, minWidth: 220 }}
              />
            )}

            {(userRole === 'SUPER_ADMIN' || userRole === 'ADMIN') && (
              <Autocomplete
                size="small"
                options={[
                  { id: '', label: 'All Uploaders' },
                  ...uploaders.map((user) => ({
                    id: user.id,
                    label: getUploaderFilterLabel(user)
                  }))
                ]}
                value={
                  !filterUploadedBy
                    ? { id: '', label: 'All Uploaders' }
                    : uploaders
                        .map((user) => ({
                          id: user.id,
                          label: getUploaderFilterLabel(user)
                        }))
                        .find((o) => o.id === filterUploadedBy) || { id: '', label: 'All Uploaders' }
                }
                onChange={(_, option) => {
                  setPage(0);
                  setFilterUploadedBy(option?.id || '');
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                renderInput={(params) => (
                  <TextField {...params} label="Uploaded By" placeholder="Search uploader..." />
                )}
                sx={{ width: 220, minWidth: 220 }}
              />
            )}

            {userRole !== 'CONTRIBUTOR' && (
              <Autocomplete
                size="small"
                options={[
                  { id: '', label: 'All Publishers' },
                  ...allPublisherEmails.map((pub) => ({
                    id: pub.email,
                    label: `${pub.email} (${pub.count.toLocaleString()})`
                  }))
                ]}
                value={
                  !filterPublisher
                    ? { id: '', label: 'All Publishers' }
                    : allPublisherEmails
                        .map((pub) => ({
                          id: pub.email,
                          label: `${pub.email} (${pub.count.toLocaleString()})`
                        }))
                        .find((o) => o.id === filterPublisher) || {
                        id: filterPublisher,
                        label: filterPublisher
                      }
                }
                onChange={(_, option) => {
                  setPage(0);
                  setFilterPublisher(option?.id || '');
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                renderInput={(params) => (
                  <TextField {...params} label="Publisher / Contact" placeholder="Search publisher..." />
                )}
                sx={{ width: 240, minWidth: 240 }}
              />
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                limitTags={2}
                size="small"
                options={availableTlds.map((item) => ({
                  id: item.tld,
                  label: `${item.tld} (${item.count.toLocaleString()})`
                }))}
                value={availableTlds
                  .filter((item) => filterTlds.includes(item.tld))
                  .map((item) => ({
                    id: item.tld,
                    label: `${item.tld} (${item.count.toLocaleString()})`
                  }))}
                onChange={(_, options) => {
                  setPage(0);
                  setFilterTlds(options.map((option) => option.id));
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="TLD"
                    placeholder={filterTlds.length ? '' : 'All TLDs'}
                  />
                )}
                sx={{ width: 280, minWidth: 220 }}
              />
              {userRole === 'SUPER_ADMIN' && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={openAdminTldDialog}
                  sx={{ height: 40, whiteSpace: 'nowrap' }}
                >
                  {adminVisibleTlds.length ? `Admin TLDs (${adminVisibleTlds.length})` : 'Set admin TLDs'}
                </Button>
              )}
            </Box>

            <Autocomplete
              size="small"
              options={[
                { id: '', label: 'All Languages' },
                ...availableLanguages.map((lang) => ({
                  id: lang.code,
                  label: `${lang.label} (${lang.count.toLocaleString()})`
                }))
              ]}
              value={
                !filterLanguage
                  ? { id: '', label: 'All Languages' }
                  : availableLanguages
                      .map((lang) => ({
                        id: lang.code,
                        label: `${lang.label} (${lang.count.toLocaleString()})`
                      }))
                      .find((o) => o.id === filterLanguage) || { id: filterLanguage, label: filterLanguage }
              }
              onChange={(_, option) => {
                setPage(0);
                setFilterLanguage(option?.id || '');
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              renderInput={(params) => (
                <TextField {...params} label="Language" placeholder="Search language..." />
              )}
              sx={{ width: 200, minWidth: 200 }}
            />

            <Autocomplete
              size="small"
              options={[
                { id: '', label: 'All Countries' },
                ...availableCountries.map((country) => ({
                  id: country.code,
                  label: `${country.label} (${country.count.toLocaleString()})`
                }))
              ]}
              value={
                !filterCountry
                  ? { id: '', label: 'All Countries' }
                  : availableCountries
                      .map((country) => ({
                        id: country.code,
                        label: `${country.label} (${country.count.toLocaleString()})`
                      }))
                      .find((o) => o.id === filterCountry) || { id: filterCountry, label: filterCountry }
              }
              onChange={(_, option) => {
                setPage(0);
                setFilterCountry(option?.id || '');
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              renderInput={(params) => (
                <TextField {...params} label="Country" placeholder="Search country..." />
              )}
              sx={{ width: 200, minWidth: 200 }}
            />

            <Autocomplete
              size="small"
              options={[
                { id: '', label: 'All Statuses' },
                { id: 'PENDING', label: 'Pending' },
                { id: 'READY_TO_SEND', label: 'Ready to send' },
                { id: 'NOT_REACHED', label: 'Email Failed' }
              ]}
              value={
                !filterStatus
                  ? { id: '', label: 'All Statuses' }
                  : [
                      { id: 'PENDING', label: 'Pending' },
                      { id: 'READY_TO_SEND', label: 'Ready to send' },
                      { id: 'NOT_REACHED', label: 'Email Failed' }
                    ].find((o) => o.id === filterStatus) || { id: '', label: 'All Statuses' }
              }
              onChange={(_, option) => {
                setPage(0);
                setFilterStatus(option?.id || '');
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              renderInput={(params) => (
                <TextField {...params} label="Status" placeholder="Filter by status..." />
              )}
              sx={{ width: 200, minWidth: 200 }}
            />

            <TextField
              size="small"
              label="Keywords From"
              type="number"
              value={filterKeywordsMin}
              onChange={(e) => setFilterKeywordsMin(e.target.value)}
              inputProps={{ min: 0 }}
              sx={{ width: 140, minWidth: 140 }}
            />

            <TextField
              size="small"
              label="Keywords To"
              type="number"
              value={filterKeywordsMax}
              onChange={(e) => setFilterKeywordsMax(e.target.value)}
              inputProps={{ min: 0 }}
              sx={{ width: 140, minWidth: 140 }}
            />

            {(debouncedSearchText || filterAssignedTo || filterUploadedBy || filterPublisher || filterLanguage || filterCountry || filterTlds.length > 0 || filterStatus !== 'PENDING' || filterKeywordsMin || filterKeywordsMax) && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<ClearIcon fontSize="small" />}
                onClick={() => {
                  setPage(0);
                  setSearchText('');
                  setDebouncedSearchText('');
                  setFilterAssignedTo('');
                  setFilterUploadedBy('');
                  setFilterPublisher('');
                  setFilterLanguage('');
                  setFilterCountry('');
                  setFilterTlds([]);
                  setFilterStatus('PENDING');
                  setFilterKeywordsMin('');
                  setFilterKeywordsMax('');
                  setDebouncedKeywordsMin('');
                  setDebouncedKeywordsMax('');
                }}
                sx={{ height: 40 }}
              >
                Clear All
              </Button>
            )}

            <Typography variant="body2" color="text.secondary" sx={{ ml: { xs: 0, md: 'auto' } }}>

              Showing {data.length} of {total} records

            </Typography>

          </Box>

          

          {/* Bulk Actions Section */}

          {selectedRows.size > 0 && userRole !== 'CONTRIBUTOR' && (

            <Box sx={{ mb: 2, p: 2, bgcolor: '#e3f2fd', borderRadius: 1, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>

              <Typography variant="body2" fontWeight="bold">

                {selectedRows.size} site(s) selected

              </Typography>

              <Button

                variant="contained"

                color="warning"

                size="small"

                disabled={bulkActionLoading}

                onClick={handleBulkMarkAsRejected}

                startIcon={bulkActionLoading ? <CircularProgress size={16} /> : null}

              >

                {bulkActionLoading ? 'Processing...' : 'Mark as Rejected'}

              </Button>

              <Button

                variant="contained"

                color="success"

                size="small"

                disabled={bulkActionLoading}

                onClick={handleBulkMarkAsReached}

                startIcon={bulkActionLoading ? <CircularProgress size={16} /> : null}

              >

                {bulkActionLoading ? 'Processing...' : 'Mark as Email Sent'}

              </Button>

              {userRole === 'SUPER_ADMIN' && (

                <Button

                  variant="contained"

                  color="error"

                  size="small"

                  disabled={bulkActionLoading}

                  onClick={handleBulkDelete}

                  startIcon={bulkActionLoading ? <CircularProgress size={16} /> : null}

                >

                  {bulkActionLoading ? 'Deleting...' : 'Delete Selected'}

                </Button>

              )}

              <Button

                variant="outlined"

                size="small"

                onClick={() => setSelectedRows(new Set())}

              >

                Clear Selection

              </Button>

            </Box>

          )}



          {loading ? (

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>

              <CircularProgress />

            </Box>

          ) : data.length === 0 ? (

            <Box sx={{ textAlign: 'center', py: 8 }}>

              <Typography variant="body1" color="text.secondary">

                No records found.

              </Typography>

            </Box>

          ) : (

            <Box sx={{ position: 'relative' }}>

              {/* Loading overlay */}

              {loading && (

                <Box

                  sx={{

                    position: 'absolute',

                    top: 0,

                    left: 0,

                    right: 0,

                    bottom: 0,

                    bgcolor: 'rgba(255, 255, 255, 0.7)',

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    zIndex: 10,

                    borderRadius: 1

                  }}

                >

                  <CircularProgress />

                </Box>

              )}

              

              <TableContainer>

                <Table>

                  <TableHead>

                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>

                    {userRole !== 'CONTRIBUTOR' && (

                      <TableCell padding="checkbox" sx={{ width: 50 }}>

                      <input

                        type="checkbox"

                        checked={paginatedData.length > 0 && paginatedData.every(row => selectedRows.has(row.id))}

                        onChange={(e) => {

                          if (e.target.checked) {

                            const newSelected = new Set(selectedRows);

                            paginatedData.forEach(row => newSelected.add(row.id));

                            setSelectedRows(newSelected);

                          } else {

                            const newSelected = new Set(selectedRows);

                            paginatedData.forEach(row => newSelected.delete(row.id));

                            setSelectedRows(newSelected);

                          }

                        }}

                      />

                    </TableCell>

                    )}

                    {userRole !== 'CONTRIBUTOR' && <TableCell align="center" sx={{ width: 50 }}><strong>Edit</strong></TableCell>}

                    <TableCell>

                      <TableSortLabel

                        active={sortBy === 'url'}

                        direction={sortBy === 'url' ? sortOrder : 'asc'}

                        onClick={() => handleSort('url')}

                      >

                        <strong>Site URL</strong>

                      </TableSortLabel>

                    </TableCell>

                    {userRole !== 'CONTRIBUTOR' && (
                      <TableCell sx={{ whiteSpace: 'nowrap' }}><strong>Quick Action</strong></TableCell>
                    )}

                    {userRole === 'SUPER_ADMIN' && showCol('publisher') && <TableCell><strong>Publisher</strong></TableCell>}

                    {userRole === 'SUPER_ADMIN' && showCol('publisherEmail') && <TableCell><strong>Publisher Email</strong></TableCell>}

                    {userRole !== 'CONTRIBUTOR' && showCol('contactName') && <TableCell><strong>Contact Name</strong></TableCell>}

                    {userRole !== 'CONTRIBUTOR' && showCol('contactEmail') && <TableCell><strong>Contact Email</strong></TableCell>}

                    {showCol('da') && <TableCell><strong>DA</strong></TableCell>}

                    {showCol('dr') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'dr'}
                        direction={sortBy === 'dr' ? sortOrder : 'asc'}
                        onClick={() => handleSort('dr')}
                      >
                        <strong>DR</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('traffic') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'traffic'}
                        direction={sortBy === 'traffic' ? sortOrder : 'asc'}
                        onClick={() => handleSort('traffic')}
                      >
                        <strong>Traffic</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('ss') && <TableCell><strong>SS</strong></TableCell>}

                    {showCol('keywords') && <TableCell><strong>Keywords</strong></TableCell>}

                    {showCol('domainAge') && <TableCell><strong>Domain Age</strong></TableCell>}

                    {showCol('gbPrice') && (
                    <TableCell>

                      <TableSortLabel

                        active={sortBy === 'price'}

                        direction={sortBy === 'price' ? sortOrder : 'asc'}

                        onClick={() => handleSort('price')}

                      >

                        <strong>GB Base Price</strong>

                      </TableSortLabel>

                    </TableCell>
                    )}

                    {showCol('liPrice') && <TableCell><strong>LI Base Price</strong></TableCell>}

                    {showCol('category') && <TableCell><strong>Category</strong></TableCell>}

                    {showCol('country') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'country'}
                        direction={sortBy === 'country' ? sortOrder : 'asc'}
                        onClick={() => handleSort('country')}
                      >
                        <strong>Country</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('language') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'language'}
                        direction={sortBy === 'language' ? sortOrder : 'asc'}
                        onClick={() => handleSort('language')}
                      >
                        <strong>Language</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('tat') && <TableCell><strong>TAT</strong></TableCell>}

                    {showCol('status') && (
                    <TableCell>

                      <TableSortLabel

                        active={sortBy === 'status'}

                        direction={sortBy === 'status' ? sortOrder : 'asc'}

                        onClick={() => handleSort('status')}

                      >

                        <strong>Status</strong>

                      </TableSortLabel>

                    </TableCell>
                    )}

                    {showCol('comment') && <TableCell><strong>Comment</strong></TableCell>}

                    {showCol('lastModified') && (
                    <TableCell>

                      <TableSortLabel

                        active={sortBy === 'lastModified'}

                        direction={sortBy === 'lastModified' ? sortOrder : 'asc'}

                        onClick={() => handleSort('lastModified')}

                      >

                        <strong>Last Modified</strong>

                      </TableSortLabel>

                    </TableCell>
                    )}

                    {userRole === 'SUPER_ADMIN' && showCol('uploadedBy') && <TableCell><strong>Uploaded By</strong></TableCell>}

                    {userRole === 'SUPER_ADMIN' && showCol('assignedTo') && <TableCell><strong>Assigned To</strong></TableCell>}

                    <TableCell align="center"><strong>Actions</strong></TableCell>

                  </TableRow>

                </TableHead>

                <TableBody>

                  {paginatedData.map((row) => (

                    <TableRow 

                      key={row.id} 

                      hover

                      selected={selectedRows.has(row.id)}

                      sx={{

                        backgroundColor: recentlyUpdated.has(row.id)

                          ? 'rgba(76, 175, 80, 0.16)'

                          : row.status === 'READY_TO_SEND'

                            ? 'rgba(2, 136, 209, 0.16)'

                            : (row.status === 'NO_ACTION_NEEDED' || row.status === 'NOT_REACHED')

                              ? 'rgba(0, 0, 0, 0.04)'

                              : 'inherit',

                        transition: 'background-color 0.3s ease',

                        '&:hover, &.Mui-selected, &.Mui-selected:hover': {

                          backgroundColor: recentlyUpdated.has(row.id)

                            ? 'rgba(76, 175, 80, 0.24)'

                            : row.status === 'READY_TO_SEND'

                              ? 'rgba(2, 136, 209, 0.26)'

                              : (row.status === 'NO_ACTION_NEEDED' || row.status === 'NOT_REACHED')

                                ? 'rgba(0, 0, 0, 0.08)'

                                : 'rgba(0, 0, 0, 0.04)'

                        }

                      }}

                    >

                      {userRole !== 'CONTRIBUTOR' && (

                        <TableCell padding="checkbox">

                          <input

                            type="checkbox"

                            checked={selectedRows.has(row.id)}

                            onChange={(e) => {

                              const newSelected = new Set(selectedRows);

                              if (e.target.checked) {

                                newSelected.add(row.id);

                              } else {

                                newSelected.delete(row.id);

                              }

                              setSelectedRows(newSelected);

                            }}

                          />

                        </TableCell>

                      )}

                      {userRole !== 'CONTRIBUTOR' && (

                        <TableCell align="center" sx={{ width: 50 }}>

                          <Tooltip title="Edit">

                            <IconButton 

                              size="small" 

                              color="primary"

                              onClick={() => handleEdit(row)}

                            >

                              <EditIcon fontSize="small" />

                            </IconButton>

                          </Tooltip>

                        </TableCell>

                      )}

                      <TableCell>

                        <Typography 

                          variant="body2" 

                          component="a"

                          href={row.websiteUrl.startsWith('http') ? row.websiteUrl : `https://${row.websiteUrl}`}

                          target="_blank"

                          rel="noopener noreferrer"

                          sx={{ 

                            fontFamily: 'monospace', 

                            fontWeight: 'bold',

                            color: 'primary.main',

                            textDecoration: 'none',

                            '&:hover': {

                              textDecoration: 'underline'

                            }

                          }}

                        >

                          {row.websiteUrl}

                        </Typography>

                      </TableCell>

                      {userRole !== 'CONTRIBUTOR' && (
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>
                          <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center' }}>
                            <Button
                              size="small"
                              variant={row.status === 'READY_TO_SEND' ? 'contained' : 'outlined'}
                              color="info"
                              disabled={row.status === 'READY_TO_SEND' || rowAction?.id === row.id}
                              onClick={() => handleRowStatusAction(row, 'READY_TO_SEND')}
                              startIcon={
                                rowAction?.id === row.id && rowAction.status === 'READY_TO_SEND'
                                  ? <CircularProgress size={14} color="inherit" />
                                  : <SendIcon sx={{ fontSize: 16 }} />
                              }
                              sx={{ textTransform: 'none', whiteSpace: 'nowrap', minWidth: 0 }}
                            >
                              Ready to send
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="inherit"
                              disabled={rowAction?.id === row.id}
                              onClick={() => handleRowStatusAction(row, 'NO_ACTION_NEEDED')}
                              startIcon={
                                rowAction?.id === row.id && rowAction.status === 'NO_ACTION_NEEDED'
                                  ? <CircularProgress size={14} color="inherit" />
                                  : <CancelIcon sx={{ fontSize: 16 }} />
                              }
                              sx={{ textTransform: 'none', whiteSpace: 'nowrap', minWidth: 0 }}
                            >
                              Reject
                            </Button>
                          </Box>
                        </TableCell>
                      )}

                      {userRole === 'SUPER_ADMIN' && showCol('publisher') && (

                        <TableCell>

                          {row.publisherMatched ? (

                            <Box>

                              <Typography variant="body2">{row.publisherName}</Typography>

                              <Typography variant="caption" color="success.main">✓ Matched</Typography>

                            </Box>

                          ) : (

                            <Typography variant="caption" color="text.secondary">Not matched</Typography>

                          )}

                        </TableCell>

                      )}

                      {userRole === 'SUPER_ADMIN' && showCol('publisherEmail') && (

                        <TableCell>

                          {row.publisherMatched ? (

                            row.publisherEmail || <Typography variant="caption" color="text.secondary">-</Typography>

                          ) : (

                            <Typography variant="caption" color="text.secondary">-</Typography>

                          )}

                        </TableCell>

                      )}

                      {userRole !== 'CONTRIBUTOR' && showCol('contactName') && (

                        <TableCell>

                          {row.publisherMatched ? (

                            <Typography variant="caption" color="text.secondary">-</Typography>

                          ) : (

                            row.contactName || <Typography variant="caption" color="text.secondary">Not set</Typography>

                          )}

                        </TableCell>

                      )}

                      {userRole !== 'CONTRIBUTOR' && showCol('contactEmail') && (

                        <TableCell>

                          {row.publisherMatched ? (

                            <Typography variant="caption" color="text.secondary">-</Typography>

                          ) : (

                            row.contactEmail || <Typography variant="caption" color="text.secondary">Not set</Typography>

                          )}

                        </TableCell>

                      )}

                      {showCol('da') && (
                      <TableCell>

                        {row.da || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('dr') && (
                      <TableCell>

                        {row.dr || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('traffic') && (
                      <TableCell>

                        {row.traffic || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('ss') && (
                      <TableCell>

                        {row.ss || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('keywords') && (
                      <TableCell>

                        {row.keywords || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('domainAge') && (
                      <TableCell>

                        {row.domainAge != null && String(row.domainAge).trim() !== ''
                          ? `${String(row.domainAge).replace(/[^0-9]/g, '')} years`
                          : <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('gbPrice') && (
                      <TableCell>

                        {row.price || row.gbBasePrice ? `$${row.price || row.gbBasePrice}` : <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('liPrice') && (
                      <TableCell>

                        {row.liBasePrice ? `$${row.liBasePrice}` : <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('category') && (
                      <TableCell>

                        {getCategoryLabel(row.category) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('country') && (
                      <TableCell>

                        {getCountryLabel(row.country) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('language') && (
                      <TableCell>

                        {getLanguageLabel(row.language) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('tat') && (
                      <TableCell>

                        {row.tat || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('status') && (
                      <TableCell>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                          {getStatusIcon(row.status)}

                          <Chip 

                            label={getStatusLabel(row.status)} 

                            color={getStatusColor(row.status) as any}

                            size="small"

                          />

                        </Box>

                      </TableCell>
                      )}

                      {showCol('comment') && (
                      <TableCell>

                        {row.comment ? (

                          <Typography variant="caption" color="text.secondary" sx={{ 

                            maxWidth: 200, 

                            overflow: 'hidden', 

                            textOverflow: 'ellipsis',

                            whiteSpace: 'nowrap',

                            display: 'block'

                          }}>

                            {row.comment}

                          </Typography>

                        ) : (

                          <Typography variant="caption" color="text.secondary">-</Typography>

                        )}

                      </TableCell>
                      )}

                      {showCol('lastModified') && (
                      <TableCell>

                        <Box>

                          <Typography variant="caption" color="text.secondary">

                            {/* For CONTRIBUTOR: show only role, not name */}

                            {userRole === 'CONTRIBUTOR' 

                              ? (row.lastModifiedByUser?.role === 'SUPER_ADMIN' ? 'Super Admin' : row.lastModifiedByUser?.role === 'ADMIN' ? 'Admin' : 'Modified')

                              : (

                                /* For ADMIN/SUPER_ADMIN: show full name */

                                row.lastModifiedByUser 

                                  ? `${row.lastModifiedByUser.firstName} ${row.lastModifiedByUser.lastName}`

                                  : (row as any).lastModifiedBy?.firstName && (row as any).lastModifiedBy?.lastName

                                  ? `${(row as any).lastModifiedBy.firstName} ${(row as any).lastModifiedBy.lastName}`

                                  : (row as any).lastModifiedByName 

                                  ? (row as any).lastModifiedByName

                                  : (row as any).modifiedBy

                                  ? (row as any).modifiedBy

                                  : row.updatedAt 

                                  ? 'Modified'

                                  : 'Not modified'

                              )

                            }

                          </Typography>

                          {row.updatedAt && (

                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>

                              {formatDate(row.updatedAt)}

                            </Typography>

                          )}

                        </Box>

                      </TableCell>
                      )}

                      {userRole === 'SUPER_ADMIN' && showCol('uploadedBy') && (

                        <TableCell>

                          <Typography variant="caption" color="text.secondary">

                            {row.uploadTask?.fileName?.startsWith('hypwave-demand-')
                              ? 'Hypwave tool'
                              : row.uploadTask?.createdByUser
                                ? `${row.uploadTask.createdByUser.firstName} ${row.uploadTask.createdByUser.lastName}`.trim()
                                : '-'}

                          </Typography>

                        </TableCell>

                      )}

                      {userRole === 'SUPER_ADMIN' && showCol('assignedTo') && (

                        <TableCell>

                          <Typography variant="caption" color="text.secondary">

                            {row.uploadTask?.assignedToUser 

                              ? `${row.uploadTask.assignedToUser.firstName} ${row.uploadTask.assignedToUser.lastName}`

                              : 'Not assigned'}

                          </Typography>

                        </TableCell>

                      )}

                      <TableCell align="center">

                        <Tooltip title="View Details">

                          <IconButton 

                            size="small" 

                            color="info"

                            onClick={() => handleView(row)}

                          >

                            <RemoveRedEyeIcon fontSize="small" />

                          </IconButton>

                        </Tooltip>

                        {userRole === 'SUPER_ADMIN' && (

                          <Tooltip title="Delete">

                            <IconButton 

                              size="small" 

                              color="error"

                              onClick={() => handleDelete(row.id)}

                              sx={{ ml: 1 }}

                            >

                              <DeleteIcon fontSize="small" />

                            </IconButton>

                          </Tooltip>

                        )}

                      </TableCell>

                    </TableRow>

                  ))}

                </TableBody>

              </Table>

            </TableContainer>

            </Box>

          )}

          

          {/* Pagination - show when data exists */}

          {data.length > 0 && (

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                <Typography variant="body2" color="text.secondary">Go to page:</Typography>

                <TextField

                  size="small"

                  type="number"

                  value={goToPageInput}

                  onChange={(e) => setGoToPageInput(e.target.value)}

                  onKeyPress={handleGoToPageKeyPress}

                  placeholder={`1-${Math.ceil(total / rowsPerPage)}`}

                  sx={{ width: 100 }}

                  inputProps={{ min: 1, max: Math.ceil(total / rowsPerPage) }}

                />

                <Button 

                  variant="outlined" 

                  size="small" 

                  onClick={handleGoToPage}

                  disabled={!goToPageInput}

                >

                  Go

                </Button>

              </Box>

              <TablePagination

                component="div"

                count={total}

                page={page}

                onPageChange={handleChangePage}

                rowsPerPage={rowsPerPage}

                onRowsPerPageChange={handleChangeRowsPerPage}

                rowsPerPageOptions={[25, 50, 100, 250, 500, 1000]}

                showFirstButton

                showLastButton

              />

            </Box>

          )}

        </CardContent>

      </Card>



      {/* View Dialog */}

      <Dialog open={showViewDialog} onClose={() => setShowViewDialog(false)} maxWidth="md" fullWidth>

        <DialogTitle>View Record Details</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          {selectedRecord && (

            <Grid container spacing={2}>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Website URL"

                  value={selectedRecord.websiteUrl}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Category"

                  value={selectedRecord.category || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Language"

                  value={selectedRecord.language || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Country"

                  value={selectedRecord.country || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Status"

                  value={getStatusLabel(selectedRecord.status)}

                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        {getStatusIcon(selectedRecord.status)}
                      </InputAdornment>
                    )
                  }}

                />

              </Grid>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Upload Source"

                  value={selectedRecord.uploadTask?.fileName || 'Unknown'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Created At"

                  value={formatDate(selectedRecord.createdAt)}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Last Modified"

                  value={selectedRecord.updatedAt ? formatDate(selectedRecord.updatedAt) : 'Not modified'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

            </Grid>

          )}

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setShowViewDialog(false)}>Close</Button>

        </DialogActions>

      </Dialog>



      {/* Edit Dialog */}

      <Dialog 

        open={showEditDialog} 

        onClose={() => {}} 

        maxWidth="md" 

        fullWidth

        disableEscapeKeyDown

      >

        <DialogTitle>Edit Record</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          {selectedRecord && (

            <Box>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>

                Site URL: 

                <Link 

                  href={selectedRecord.websiteUrl.startsWith('http') ? selectedRecord.websiteUrl : `https://${selectedRecord.websiteUrl}`}

                  target="_blank"

                  rel="noopener noreferrer"

                  sx={{ 

                    fontWeight: 'bold',

                    ml: 1,

                    textDecoration: 'none',

                    '&:hover': {

                      textDecoration: 'underline'

                    }

                  }}

                >

                  {selectedRecord.websiteUrl}

                </Link>

                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>

                  (Non-editable)

                </Typography>

              </Typography>

              

              <Grid container spacing={2}>

                {/* Publisher info - only visible to Super Admin when matched */}

                {userRole === 'SUPER_ADMIN' && editFormData.publisherMatched && (

                  <>

                    <Grid item xs={12}>

                      <Alert severity="success" sx={{ mb: 1 }}>

                        Publisher matched from LM Tool: <strong>{editFormData.publisherName}</strong>

                      </Alert>

                    </Grid>

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Publisher Name"

                        value={editFormData.publisherName}

                        onChange={(e) => setEditFormData({...editFormData, publisherName: e.target.value})}

                      />

                    </Grid>

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Publisher Email"

                        value={editFormData.publisherEmail || ''}

                        onChange={(e) => setEditFormData({...editFormData, publisherEmail: e.target.value})}

                      />

                    </Grid>

                  </>

                )}

                

                {/* Contact fields - only visible when publisher is NOT matched */}

                {!editFormData.publisherMatched && (

                  <>

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Contact Name"

                        value={editFormData.contactName}

                        onChange={(e) => setEditFormData({...editFormData, contactName: e.target.value})}

                        placeholder="Enter contact person name"

                        helperText="Name of the contact person for this site"

                      />

                    </Grid>

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Contact Email"

                        type="email"

                        value={editFormData.contactEmail}

                        onChange={(e) => setEditFormData({...editFormData, contactEmail: e.target.value})}

                        placeholder="contact@example.com"

                        helperText="Email of the contact person for this site"

                      />

                    </Grid>

                    

                    {/* Mark as Publisher button - Super Admin only, when contact info exists */}

                    {userRole === 'SUPER_ADMIN' && (editFormData.contactName || editFormData.contactEmail) && (

                      <Grid item xs={12}>

                        <Box sx={{ p: 2, bgcolor: 'info.lighter', borderRadius: 1, border: '1px solid', borderColor: 'info.main' }}>

                          <Button

                            variant="contained"

                            color="info"

                            onClick={handleCreatePublisherFromEdit}

                            disabled={creatingPublisher}

                            startIcon={creatingPublisher ? <CircularProgress size={16} /> : null}

                            sx={{ mb: 1 }}

                          >

                            {creatingPublisher ? 'Marking...' : 'Mark as Publisher'}

                          </Button>

                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>

                            This will save the contact info as publisher details. When you push this record to the LM Tool:

                          </Typography>

                          <Typography variant="body2" color="text.secondary" component="ul" sx={{ mt: 0.5, pl: 2 }}>

                            <li>If a publisher with this email already exists in LM Tool, it will be linked automatically</li>

                            <li>If not, a new publisher will be created in the LM Tool</li>

                            <li>Other sites with the same contact email will also use this publisher</li>

                          </Typography>

                        </Box>

                      </Grid>

                    )}

                  </>

                )}

                {/* Metrics: 3 cols/row; Domain Age after TAT */}
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="DA"
                    type="number"
                    value={editFormData.da}
                    onChange={(e) => setEditFormData({...editFormData, da: e.target.value})}
                    inputProps={{ min: 0, max: 100 }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    required
                    label="DR"
                    type="number"
                    value={editFormData.dr}
                    onChange={(e) => setEditFormData({...editFormData, dr: e.target.value})}
                    inputProps={{ min: 0, max: 100 }}
                    error={!editFormData.dr}
                    helperText={!editFormData.dr ? 'Required' : ''}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    required
                    label="Traffic"
                    type="number"
                    value={editFormData.traffic}
                    onChange={(e) => setEditFormData({...editFormData, traffic: e.target.value})}
                    error={!editFormData.traffic}
                    helperText={!editFormData.traffic ? 'Required' : ''}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="SS"
                    type="number"
                    value={editFormData.ss}
                    onChange={(e) => setEditFormData({...editFormData, ss: e.target.value})}
                    inputProps={{ min: 0, max: 100 }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Keywords"
                    type="number"
                    value={editFormData.keywords}
                    onChange={(e) => setEditFormData({...editFormData, keywords: e.target.value})}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
                {userRole === 'SUPER_ADMIN' ? (
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="GB Base Price ($)"
                      type="number"
                      value={editFormData.gbBasePrice}
                      onChange={(e) => setEditFormData({...editFormData, gbBasePrice: e.target.value})}
                      inputProps={{ min: 0, step: 0.01 }}
                      placeholder="e.g., 50"
                    />
                  </Grid>
                ) : (
                  <Grid item xs={4}>
                    <Autocomplete
                      options={[...categories].sort((a, b) => a.label.localeCompare(b.label))}
                      getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                      value={toAutocompleteOption(categories, editFormData.category, 'category')}
                      onChange={(_, newValue) => setEditFormData({...editFormData, category: newValue?.value || ''})}
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      renderInput={(params) => (
                        <TextField {...params} label="Category" />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={4}>
                  <Autocomplete
                    options={LANGUAGES}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                    value={toAutocompleteOption(LANGUAGES, editFormData.language, 'language')}
                    onChange={(_, newValue) => setEditFormData({...editFormData, language: newValue?.value || ''})}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Language" />
                    )}
                  />
                </Grid>
                {userRole === 'SUPER_ADMIN' && (
                  <Grid item xs={4}>
                    <Autocomplete
                      options={[...categories].sort((a, b) => a.label.localeCompare(b.label))}
                      getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                      value={toAutocompleteOption(categories, editFormData.category, 'category')}
                      onChange={(_, newValue) => setEditFormData({...editFormData, category: newValue?.value || ''})}
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      renderInput={(params) => (
                        <TextField {...params} label="Category" />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={4}>
                  <Autocomplete
                    options={COUNTRIES}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                    value={toAutocompleteOption(COUNTRIES, editFormData.country, 'country')}
                    onChange={(_, newValue) => setEditFormData({...editFormData, country: newValue?.value || ''})}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Country" />
                    )}
                  />
                </Grid>
                {userRole === 'SUPER_ADMIN' && (
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="LI Base Price ($)"
                      type="number"
                      value={editFormData.liBasePrice}
                      onChange={(e) => setEditFormData({...editFormData, liBasePrice: e.target.value})}
                      inputProps={{ min: 0, step: 0.01 }}
                      placeholder="e.g., 75"
                    />
                  </Grid>
                )}
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="TAT (Turnaround Time)"
                    value={editFormData.tat}
                    onChange={(e) => setEditFormData({...editFormData, tat: e.target.value})}
                    placeholder="e.g., 1-2 days"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Domain Age"
                    type="number"
                    value={editFormData.domainAge}
                    onChange={(e) => setEditFormData({...editFormData, domainAge: e.target.value})}
                    placeholder="e.g., 6"
                    inputProps={{ min: 0 }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={editFormData.status}
                      label="Status"
                      onChange={(e) => setEditFormData({...editFormData, status: e.target.value})}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {getStatusIcon(String(selected))}
                          {getStatusLabel(String(selected))}
                        </Box>
                      )}
                    >
                      <MenuItem value="PENDING">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <AccessTimeIcon fontSize="small" sx={{ color: '#ff9800' }} /> Pending
                        </Box>
                      </MenuItem>
                      <MenuItem value="READY_TO_SEND">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <SendIcon fontSize="small" sx={{ color: '#0288d1' }} /> Ready to send
                        </Box>
                      </MenuItem>
                      <MenuItem value="REACHED">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <MarkEmailReadIcon fontSize="small" sx={{ color: '#2e7d32' }} /> Email Sent
                        </Box>
                      </MenuItem>
                      <MenuItem value="NOT_REACHED">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <MarkEmailUnreadIcon fontSize="small" sx={{ color: '#d32f2f' }} /> Email Failed
                        </Box>
                      </MenuItem>
                      <MenuItem value="NO_ACTION_NEEDED">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CancelIcon fontSize="small" sx={{ color: '#616161' }} /> Rejected
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

              </Grid>

              

              {/* Comment field - shown when Rejected or Not Reached is selected */}

              {(editFormData.status === 'NO_ACTION_NEEDED' || editFormData.status === 'NOT_REACHED') && (

                <Grid container spacing={2} sx={{ mt: 1 }}>

                  <Grid item xs={12}>

                    <TextField

                      fullWidth

                      multiline

                      rows={3}

                      label="Comment (Optional)"

                      value={editFormData.comment}

                      onChange={(e) => setEditFormData({...editFormData, comment: e.target.value})}

                      placeholder={

                        editFormData.status === 'NO_ACTION_NEEDED' 

                          ? "Optional: Provide a reason for rejecting this record..."

                          : "Optional: Provide details about why email failed..."

                      }

                      helperText="You can optionally add a comment to provide additional context."

                    />

                  </Grid>

                </Grid>

              )}

              

              {editFormData.status === 'REACHED' && (

                <Grid container spacing={2} sx={{ mt: 1 }}>

                  <Grid item xs={12}>

                    <TextField

                      fullWidth

                      label="Image Link"

                      value={editFormData.imageLink}

                      onChange={(e) => setEditFormData({...editFormData, imageLink: e.target.value})}

                      placeholder="https://prnt.sc/..."

                      helperText="Optional: paste a screenshot / image URL for this Email Sent record."

                    />

                  </Grid>

                  <Grid item xs={12}>

                    <Alert severity="info">

                      <strong>Note:</strong> Marking as "Email Sent" will move this record to Data Final page.

                    </Alert>

                  </Grid>

                </Grid>

              )}

              

              {editFormData.status === 'NO_ACTION_NEEDED' && (

                <Alert severity="info" sx={{ mt: 2 }}>

                  <strong>Note:</strong> You can optionally add a comment explaining why this record was rejected.

                </Alert>

              )}

              

              {editFormData.status === 'NOT_REACHED' && (

                <Alert severity="info" sx={{ mt: 2 }}>

                  <strong>Note:</strong> You can optionally add a comment explaining why this site could not be reached.

                </Alert>

              )}

            </Box>

          )}

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setShowEditDialog(false)} disabled={saving}>

            Cancel

          </Button>

          <Button 

            onClick={handleSaveEdit} 

            variant="contained" 

            disabled={saving}

            startIcon={saving ? <CircularProgress size={16} /> : null}

          >

            {saving ? 'Saving...' : 'Save Changes'}

          </Button>

        </DialogActions>

      </Dialog>



      <Dialog
        open={adminTldDialogOpen}
        onClose={() => !savingAdminTlds && setAdminTldDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>TLDs visible to admins</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Admins only see sites on the TLDs you select here, and those are the only TLDs in their filter.
            Leave this empty if admins should see every TLD. You and other super admins still see all data.
          </Typography>
          <Autocomplete
            multiple
            disableCloseOnSelect
            options={adminTldCatalog.map((item) => item.tld)}
            value={adminTldDraft}
            onChange={(_, value) => setAdminTldDraft(value)}
            renderInput={(params) => (
              <TextField {...params} label="Allowed TLDs" placeholder="Search TLDs..." />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAdminTldDialogOpen(false)} disabled={savingAdminTlds}>
            Cancel
          </Button>
          <Button variant="contained" onClick={saveAdminTlds} disabled={savingAdminTlds}>
            {savingAdminTlds ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Reject Dialog */}

      <Dialog

        open={showBulkRejectDialog}

        onClose={() => !bulkActionLoading && setShowBulkRejectDialog(false)}

        maxWidth="sm"

        fullWidth

      >

        <DialogTitle>Mark {selectedRows.size} site(s) as Rejected</DialogTitle>

        <DialogContent>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>

            These sites will be moved to Rejected Data. You can optionally add a comment for all selected sites.

          </Typography>

          <TextField

            fullWidth

            multiline

            rows={4}

            label="Comment (Optional)"

            value={bulkRejectComment}

            onChange={(e) => setBulkRejectComment(e.target.value)}

            placeholder="Optional: Provide a reason for rejecting these records..."

            disabled={bulkActionLoading}

          />

        </DialogContent>

        <DialogActions>

          <Button

            onClick={() => setShowBulkRejectDialog(false)}

            disabled={bulkActionLoading}

          >

            Cancel

          </Button>

          <Button

            onClick={handleConfirmBulkReject}

            variant="contained"

            color="warning"

            disabled={bulkActionLoading}

            startIcon={bulkActionLoading ? <CircularProgress size={16} /> : null}

          >

            {bulkActionLoading ? 'Rejecting...' : 'Mark as Rejected'}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Toast Notification Snackbar */}

      <Snackbar

        open={snackbar.open}

        autoHideDuration={4000}

        onClose={() => setSnackbar({ ...snackbar, open: false })}

        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}

      >

        <Alert 

          onClose={() => setSnackbar({ ...snackbar, open: false })} 

          severity={snackbar.severity}

          sx={{ 

            width: '100%',

            color: '#ffffff',

            '& .MuiAlert-icon': {

              color: '#ffffff'

            }

          }}

          variant="filled"

        >

          {snackbar.message}

        </Alert>

      </Snackbar>

    </Box>

  );

};



export default DataManagement;

